import React, { useEffect, useState } from 'react';

// material-ui
import {
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project Import
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

export default function PriceList({ venueUuid }) {

    const theme = useTheme();
    const [rows, setRows] = useState([]);

    const getPriceListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
    };

    const getPriceListApi = useApi(VenueService.getPriceList, getPriceListHandler);

    useEffect(() => {
        getPriceListApi.execute({ venueUuid });
    }, []);

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ pl: 3 }}>#</TableCell>
                            <TableCell>Sports Type</TableCell>
                            <TableCell>Weekday Price</TableCell>
                            <TableCell>Weekend Price</TableCell>
                            <TableCell>Holiday Price</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.map((row, index) =>
                                <TableRow hover key={index}>
                                    <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                    <TableCell>{row.display_name}</TableCell>
                                    <TableCell>{row.weekday_price}</TableCell>
                                    <TableCell>{row.weekend_price}</TableCell>
                                    <TableCell>{row.holiday_price}</TableCell>
                                    <TableCell>
                                        {
                                            row.is_active === 1 ? (
                                                <Chip
                                                    label="Active"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label="Inactive"
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            )
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );
};